// @flow

import { combineReducers } from 'redux';

import { userReducer, managedUserReducer } from './components/user/reducers';
import { activeOrderReducer, qbTokenReducer } from './components/orders-v2/reducers';
import { suppliersReducer, ghostSupplierReducer } from './components/supplier/reducers';
import { brandsReducer } from './components/brands/reducers';
import { categoryReducer } from './components/category/reducers';
import { promoPaymentReducer } from './components/promo/payment/reducer';
import { quotationReducer } from './components/quotation/reducers';
import { adminsReducer } from './components/admin/reducers';
import { categoryFeatureReducer } from './components/category-feature/reducers'

// import { userReducer } from './components/user/reducers' ;
// import { ordersReducer } from './components/order/reducers';
// import { activeProductReducer } from './components/supply-add-product/reducers';
// import { categoryReducers } from './components/supply-category/reducers';
// import { searchResultsReducer, ISearchResultsReducer } from './components/toolbar/reducers';
// import { activeProductsReducer } from './components/products/reducers';
// import { filtersReducer, IFiltersReducer } from './components/sidebar/reducers';
// import { cartReducer } from './components/cart/reducers';

/**
 * EEZEE COMPONENTS
 */

const _reducers = {
  activeOrder: activeOrderReducer,
  admins: adminsReducer,
  brands: brandsReducer,
  categories: categoryReducer,
  categoryFeatures: categoryFeatureReducer,
  ghostSupplier: ghostSupplierReducer,
  managedUser: managedUserReducer,
  paymentPromo: promoPaymentReducer,
  qbToken: qbTokenReducer,
  quotation: quotationReducer,
  suppliers: suppliersReducer,
  user: userReducer,

  // user: userReducer,
  // orders: ordersReducer,
  // activeProduct: activeProductReducer,
  // productCategories: categoryReducers
//   searchResults: searchResultsReducer,
//   activeProducts: activeProductsReducer,
//   filters: filtersReducer,
//   cart: cartReducer
}

export const reducers = combineReducers(_reducers);



// WEBPACK FOOTER //
// ./src/rootReducer.js